import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { updateWindow } from "../../api/Booking"

/* Helpers */
import { utils } from "../../helpers"

/* Timezone — окно набирается в ВЫБРАННОЙ зоне, а не в зоне машины */
import { currentOffsetHours, offsetLabel, wallToUtc, utcToWall } from "../../helpers/timezone"

/* Icons */
import { CloseIcon, ClockIcon, CalendarIcon, TableIcon } from "./BookingIcons"

/* Utils */
import { getGame, getPlayerName, formatRange, formatWhen } from "./BookingUtils"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Moment */
import moment from "moment"

/* DatePicker Settings */
registerLocale("ru", ru)


/* STEP OF THE TIME PICKER, IN MINUTES — THE SAME STEP THE FORM OF A NEW RESERVATION USES */
const STEP = 15

/* READY MADE LENGTHS OF A WINDOW, IN MINUTES */
const LENGTHS = [60, 120, 180, 240]

/* QUICK MOVES OF THE END OF THE WINDOW, IN MINUTES — A GUEST WHO STAYS LONGER IS ONE CLICK AWAY */
const SHIFTS = [-60, -30, -15, 15, 30, 60]

/* THE SHORTEST WINDOW THAT STILL MEANS SOMETHING, IN MINUTES — THE CONTROLLER KEEPS THE VERY SAME NUMBER */
const MIN_MINUTES = 5

/* EMPTY STATE */
const EMPTY = {
    item: null,
    start: null,
    end: null,
    waiting: false,
}


/* Widget Booking Window — продлить или сократить время уже существующей брони */
class BookingWindow extends Component {

    constructor() {
        super()
        this.state = { visible: false, ...EMPTY }
    }

    /* Open Action — the borders of the row come in UTC, the pickers work in the wall clock of the panel */
    open = (item) => {

        /* Check Booking */
        if (!item) {
            return
        }

        this.setState({
            visible: true,
            ...EMPTY,
            item,
            start: utcToWall(item.startAt),
            end: utcToWall(item.endAt),
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, ...EMPTY })
    }

    /* Read The Error Message Of A Response */
    message = (response) => {

        if (response && response.data && response.data.message) {
            return response.data.message
        }

        if (response && response.status === 498) {
            return t("swal.invalidKey")
        }

        if (response && (response.status === 401 || response.status === 403)) {
            return t("swal.noAccess")
        }

        return t("swal.generic")
    }

    /* Length Of The Window Right Now, IN MINUTES */
    getLength = () => {

        /* Fields */
        const { start, end } = this.state

        /* Check Borders */
        if (!start || !end) {
            return 0
        }

        /* Send Result */
        return moment(end).diff(moment(start), "minutes")
    }

    /* Change Start — the end follows the start and keeps the length of the window */
    changeStart = (date) => {

        /* Check Value */
        if (!date) {
            return
        }

        /* Fields */
        const length = this.getLength()

        this.setState({ start: date, end: moment(date).add(length > 0 ? length : 60, "minutes").toDate() })
    }

    /* Set The Length Of The Window — the start stays, the end moves */
    setLength = (minutes) => {

        /* Fields */
        const { start } = this.state

        /* Check Start */
        if (!start) {
            return
        }

        /* Length — a window shorter than the minimum is not written anywhere */
        const length = minutes < MIN_MINUTES ? MIN_MINUTES : minutes

        this.setState({ end: moment(start).add(length, "minutes").toDate() })
    }

    /* Extend Or Shorten — the end of the window jumps by the given number of minutes */
    shift = (minutes) => {
        this.setLength(this.getLength() + minutes)
    }

    /* Has The Window Really Changed */
    isChanged = () => {

        /* Fields */
        const { item, start, end } = this.state

        /* Check Borders */
        if (!item || !start || !end) {
            return false
        }

        /* Send Result */
        return wallToUtc(start) !== new Date(item.startAt).toISOString() || wallToUtc(end) !== new Date(item.endAt).toISOString()
    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { item, start, end } = this.state
        const { reload } = this.props

        /* Check Borders */
        if (!item || !start || !end) {
            Swal.fire(utils.notification(t("book.error.selectWindow"), "error"))
            return
        }

        /* Check Order */
        if (this.getLength() <= 0) {
            Swal.fire(utils.notification(t("book.error.wrongWindow"), "error"))
            return
        }

        /* Check Change */
        if (!this.isChanged()) {
            Swal.fire(utils.notification(t("book.error.sameWindow"), "error"))
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Send to REST API */
        updateWindow({ id: item.id, start: wallToUtc(start), end: wallToUtc(end) }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("book.windowSuccess"), "success"))
                reload()
                this.close()
            }
            else {
                Swal.fire(utils.notification(this.message(response), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    /* Length Written In Words */
    getLengthText = (minutes) => {

        /* Check Value */
        if (minutes < 60) {
            return `${minutes} ${t("book.unit.minutes")}`
        }

        /* Fields */
        const hours = Math.floor(minutes / 60)
        const rest = minutes % 60

        /* Send Result */
        return rest === 0
            ? `${hours} ${t("book.unit.hours")}`
            : `${hours} ${t("book.unit.hours")} ${rest} ${t("book.unit.minutes")}`
    }

    /* Draw Booking — which reservation is being moved */
    _booking = () => {

        /* Fields */
        const { item } = this.state

        return (
            <div className="bkg--hint">
                <TableIcon size={14} />
                <span>{getGame(item)} · {getPlayerName(item)} · {item.player}</span>
            </div>
        )
    }

    /* Draw Window */
    _window = () => {

        /* Fields */
        const { start, end } = this.state
        const length = this.getLength()

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <ClockIcon />
                        {t("book.window")}
                    </div>
                    <div className="bkg--section-note">{offsetLabel(currentOffsetHours())}</div>
                </div>

                <div className="bkg--range">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.changeStart(date)}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        timeIntervals={STEP}
                        placeholderText={t("book.from")}
                    />

                    <DatePicker
                        selected={end}
                        onChange={(date) => date && this.setState({ end: date })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        timeIntervals={STEP}
                        placeholderText={t("book.to")}
                    />

                </div>

                {/* Quick Moves Of The End */}
                <div className="bkg--chips small">
                    {SHIFTS.map((item, index) =>
                        <div
                            onClick={() => this.shift(item)}
                            className="bkg--length"
                            key={`${index}`}
                        >
                            {item > 0 ? "+" : "−"}{Math.abs(item) < 60 ? `${Math.abs(item)} ${t("book.unit.minutes")}` : `${Math.abs(item) / 60} ${t("book.unit.hours")}`}
                        </div>
                    )}
                </div>

                {/* Ready Made Lengths */}
                <div className="bkg--chips small">
                    {LENGTHS.map((item, index) =>
                        <div
                            onClick={() => this.setLength(item)}
                            className={`bkg--length ${length === item ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item < 60 ? `${item} ${t("book.unit.minutes")}` : `${item / 60} ${t("book.unit.hours")}`}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw Result — what the row said before and what it will say after saving */
    _result = () => {

        /* Fields */
        const { item, start, end } = this.state
        const length = this.getLength()

        return (
            <div className="bkg--section">

                <div className="bkg--hint">
                    <ClockIcon size={14} />
                    <span>{t("book.was")}: {formatWhen(item.startAt)} {formatRange(item)}</span>
                </div>

                {start && end && length > 0 &&
                    <div className="bkg--hint">
                        <CalendarIcon size={14} />
                        <span>
                            {t("book.becomes")}: {moment(start).format("DD.MM HH:mm")} — {moment(end).format(moment(start).isSame(moment(end), "day") ? "HH:mm" : "DD.MM HH:mm")}
                            {" · "}
                            {t("book.lengthHint")} {this.getLengthText(length)}
                        </span>
                    </div>
                }

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, waiting, item } = this.state
        const changed = this.isChanged()

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="bkg--modal"
                overlayClassName="bkg--overlay"
                closeTimeoutMS={200}
            >

                <div className="bkg--modal-header">

                    <div className="bkg--modal-icon">
                        <ClockIcon size={18} />
                    </div>

                    <div className="bkg--modal-head-text">
                        <h2>{t("book.windowTitle")}</h2>
                        <p>{t("book.windowSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="bkg--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                {/* Body */}
                {item &&
                    <div className="bkg--modal-body">

                        {/* Draw Booking */}
                        {this._booking()}

                        {/* Draw Window */}
                        {this._window()}

                        {/* Draw Result */}
                        {this._result()}

                    </div>
                }

                <div className="bkg--modal-footer">

                    <div onClick={() => this.close()} className="bkg--button ghost">{t("common.cancel")}</div>

                    {waiting
                        ? <div className="bkg--button primary"><div className="bkg--loading small" /></div>
                        : <div onClick={() => changed && this.save()} className={`bkg--button primary ${changed ? "" : "disabled"}`}>{t("book.windowButton")}</div>
                    }

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
    timezone: state.timezone,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(BookingWindow)
